module.exports = __webpack_public_path__ + "img/22.0b848c2d.webp";